<template>
    <div class="order-wrapper">
        <div class="container">
            <h1 class="order-title">
                {{ $t('course_order') }}: {{ course.course }}
            </h1>

            <div>
                <div class="ui-steeps mb-6">
                    <ul class="ui-steeps__header">
                        <li class="ui-steep-header-item is-active">
                            <div class="ui-steep-header-item__text">
                                1. {{ $t('order') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                2. {{ $t('payment') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                <span class="d-none d-sm-block">3. {{ $t('payment_information') }}</span>
                                <span class="d-block d-sm-none">3. {{ $t('abput_payment') }}</span>
                            </div>
                        </li>
                    </ul>
                </div><!-- /.ui-steeps -->

                <div v-if="$route.query.hasOwnProperty('addonly')" class="col-12 col-xl-6 offset-xl-3 mt-xl-5 mb-xl-5">
                    <div class="dop-pack-yellow rounded-xl-7 activated">
                        <div class="dop-pack-name">{{ $t('dop_pack_title') }}:</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_1') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_2') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_3') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_4') }}</div>
                        <div class="dop-pack-item">{{ $t('dop_pack_item_5') }}</div>
                        <div class="dop-pack-price"
                             v-if="course.additional_package_price">
                            <span class="dop-pack-price-value">{{course.additional_package_price}}</span> <span
                                class="dop-pack-rub">{{ $t('cur') }}</span>
                            <span class="dop-pack-before" v-if="course.additional_package_price_before">{{course.additional_package_price_before}} {{ $t('cur') }}</span>
                        </div>
                    </div>
                </div>
                <course-list-item
                        v-else
                        :course="course"
                        :hideButton="true"
                        :hideAdd="!$route.query.hasOwnProperty('add')"
                        :hideAddSwitch="true"
                        :activated="$route.query.hasOwnProperty('add')"
                        :showRecurrentParam="!fullPrice"
                        :recurrentParamDisabled="true"
                        @recurrentParamUpdate="(v) => recurrentParam=v"
                />

                <div class="partial_pay" v-if="course.partial_pay">
                    {{ $t('pay_full') }}
                  <span :class="{ 'is-active': fullPrice }" @click="fullPrice = true">{{ course.price | formatPrice }}{{ $t('cur') }}&nbsp;<sup>{{ $t('economy') }}&nbsp;{{ (course.price - course.partial_pay_amount * course.partial_pays_count) | formatPrice }}{{ $t('cur') }}</sup></span>
                  {{course.partial_pay_title}}&nbsp;*
                    <span :class="{ 'is-active': !fullPrice, 'ml-2' : !fullPrice }" @click="fullPrice = false">{{course.partial_pay_amount | formatPrice}}{{ $t('cur') }} <sup>&#215;&nbsp;{{course.partial_pays_count}}&nbsp;{{ $t('mon') }}</sup></span>
                </div>

                <div class="partial_pay" v-if="course.partial_pay && !fullPrice">
                  <span class="strong-black" v-html="$t('reccurent_notice_rules')"></span>
                </div>

                <h2 class="order-subtitle mt-2">
                    {{ $t('please_fill_out_the_form') }}
                </h2>


                <div v-if="error">
                    <base-alert type="danger">{{error}}</base-alert>
                </div>

                <div class="row justify-content-center">
                    <div class="col-sm-6 col-md-4" v-if="!user.email">
                        <label class="order-form__label" for="name">Email</label>
                        <base-input alternative=""
                                    :error="fieldError('email')"
                                    id="email"
                                    class="order-form__control"
                                    :placeholder="`${$t('enter_your_email')}*`"
                                    v-model="email"
                                    @input="setEdited"
                        />
                        <div v-if="!user.email && !isAuthenticated() && existingEmail">
                            <base-alert type="danger">
                                {{ $t('email_already_exists_') }}
                                <router-link
                                        :to="`/user/signin?return=` + returnUrl() + `&login=` + encodeURIComponent(existingEmail)"
                                        class="conrifm-email-order">{{ $t('login_now') }}</router-link>
                                {{ $t('_login_or_enter_another_email') }}
                            </base-alert>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <label class="order-form__label" for="name">{{ $t('name') }}</label>
                        <base-input alternative=""
                                    :error="fieldError('name')"
                                    id="name"
                                    class="order-form__control"
                                    :placeholder="$t('enter_your_name')"
                                    v-model="profile.name"
                                    @input="setEdited"
                        />
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <label class="order-form__label" for="name">{{ $t('phone') }}</label>
                        <base-input alternative=""
                                    :error="fieldError('phone')"
                                    id="phone"
                                    class="order-form__control"
                                    :placeholder="$t('enter_your_phone')"
                                    v-model="profile.phone"
                                    @input="setEdited"
                        />
                        <div v-if="!isAuthenticated() && existingPhone">
                            <base-alert type="danger">
                                {{ $t('phone_already_exists_') }}
                                <router-link
                                        :to="`/user/signin?return=` + returnUrl() + `&login=` + encodeURIComponent(existingPhone)"
                                        class="conrifm-email-order">{{ $t('login_now') }}</router-link>
                                {{ $t('_login_or_enter_another_phone') }}
                            </base-alert>
                        </div>
                    </div>

                    <div :class="['col-sm-6', user.email ? 'col-md-4' : 'col-md-9']">
                        <label class="order-form__label" for="name">{{ $t('comment') }}</label>
                        <base-input alternative=""
                                    id="comment"
                                    class="order-form__control"
                                    :placeholder="$t('comment_to_order')"
                                    v-model="comment"
                                    @input="setEdited"
                        />
                    </div>

                    <div class="w-100"></div>

                    <!--
                    <div class="col-sm-6 col-md-3">
                        <label class="order-form__label" for="country">Страна</label>
                        <select class="form-control order-form__control" name="country" id="country" v-model="country"
                                @change="setEdited">
                            <option :value="null">Выберите страну</option>
                            <option v-for="(item, index) in countries" :key="index">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <label class="order-form__label" for="region">Регион</label>
                        <select class="form-control order-form__control" name="region" id="region" v-model="region"
                                @change="setEdited">
                            <option :value="null">Выберите регион</option>
                            <option v-for="(item, index) in regions" :key="index">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <label class="order-form__label" for="city">Город</label>
                        <select class="form-control order-form__control" name="city" id="city" v-model="profile.city"
                                @change="setEdited">
                            <option :value="null">Выберите город</option>
                            <option v-for="(item, index) in cities" :key="index">{{item.name}}</option>
                        </select>
                    </div>
                    -->
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-sm-6 col-md-3 offset-md-3">
                        <base-input :placeholder="$t('use_promocode')" v-model="promocode"/>
                    </div>

                    <div class="col-sm-6 col-md-3 zapis">
                        <base-button
                                :data-id="course.idcourse"
                                data-model="course"
                                :data-price="course.price"
                                data-action="gotoPayment"
                                :data-label="course.price == 0 ? $t('get_free') : $t('go_to_payment')"
                                type="primary"
                                class="btn-block"
                                :disabled="disablePayButton"
                                v-if="course && course.idcourse && !assigned"
                                @click="gotoPayment"
                        >
                            <span v-if="course.price == 0">
                                {{ $t('get_free') }}
                            </span>
                            <span v-else-if="course.partial_pay && fullPrice">
                                {{ $t('go_to_payment') }} {{ course.price | formatPrice }}{{ $t('cur') }}
                            </span>
                            <span v-else-if="course.partial_pay && !fullPrice">
                                {{ $t('go_to_payment') }} {{course.partial_pay_amount | formatPrice}}{{ $t('cur') }}
                            </span>
                            <span v-else>
                                {{ $t('go_to_payment') }}
                            </span>
                            <i class="fa fa-arrow-right ml-2"></i>
                        </base-button>

                        <p
                                v-else
                                class="my-0"
                        >
                            <span v-if="course && course.idcourse">{{ $t('course_already_ordered') }}</span>
                        </p>
                    </div>
                </div><!-- /.row -->
            </div>
        </div>
    </div>
</template>

<script>
    import JwtService, {isAuthenticated} from "../data/jwt.service";
    import userApi from "../data/UserApi";
    import CourseListItem from "./CourseListItem";
    import axios from 'axios'
    import CStorage from "../data/CStorage";
    import numeral from 'numeral';
    import {androidOrderCourse} from "../data/AndroidApi";

    export default {
        name: 'order',
        props: ['idcourse'],
        components: {
            CourseListItem,
        },
        data() {
            return {
                user: {email: null},
                profile: {name: null, phone: null, city: null, country: null},
                editProfile: false,
                course: {},
                country: null,
                region: null,
                countries: [],
                regions: [],
                cities: [],
                promocode: '',

                error: null,
                fieldsErrors: [],
                loading: false,
                assigned: false,
                disablePayButton: false,

                phone: null,
                comment: null,
                email: null,

                existingEmail: null,
                existingPhone: null,

                fullPrice: true,
                recurrentParam: true,
            }
        },

        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        },
        watch: {
            country: async function (val) {
                const countryItem = this.getBy('name', val, this.countries)
                if (!countryItem.hasOwnProperty('id')) return []
                const response = await axios({method: 'get', url: '/regions?filter[country_id]=' + countryItem.id})
                this.regions = response.data
                this.profile.country = val
            },
            region: async function (val) {
                const regionItem = this.getBy('name', val, this.regions)
                if (!regionItem.id) return []
                const response = await axios({method: 'get', url: '/cities?filter[region_id]=' + regionItem.id})
                this.cities = response.data
                //this.profile.region = val
            },
        },
        async mounted() {
            androidOrderCourse(this.idcourse)
            axios({method: 'get', url: '/courses/' + this.idcourse}).then(async response => {
                this.course = response.data
                this.fullPrice = !this.course.partial_pay
            })

            let resp = await axios({method: 'get', url: '/countries'})
            this.countries = resp.data

            if (!isAuthenticated()) {
                this.user = {}
                this.profile = {}
            } else {
                this.fetchProfile()
            }
        },

        methods: {
            fetchProfile() {
                userApi.fetchProfile()
                    .then(async response => {
                        this.user = response
                        this.profile = Object.assign({}, this.user.profile)
                        if (!this.profile.phone && this.user.phone)
                            this.profile.phone = this.user.phone
                        this.courses = this.user.userCourses
                        if (!this.profile.country) {
                            this.profile.country = this.$t('default_country')
                            this.setEdited()
                        }
                        this.country = this.profile.country
                        this.cities = [{name: this.profile.city}]
                        const assignedCourse = this.getBy('course_id', parseInt(this.idcourse), this.user.userCourses)
                        this.assigned = (assignedCourse.course_id && !this.$route.query.hasOwnProperty('addonly')) || !!assignedCourse.additional_package_price
                    })
                    .catch(error => {
                        let data = (error && error.response) ? error.response.data : {}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            },

            async submitProfileChange() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                this.editProfile = false
                try {
                    this.user.profile = await userApi.updateProfileAsync(this.profile)
                    this.profile = Object.assign({}, this.user.profile)
                    JwtService.saveUser(this.user)
                    this.loading = false
                } catch (error) {
                    this.editProfile = true
                    let data = error.response.data
                    if (error.response.status === 422) {
                        this.fieldsErrors = data
                    } else if (error.response.status === 401) {
                        this.error = this.$t('error_401')
                    } else {
                        this.error = this.pretty(data)
                    }
                    this.loading = false
                }
            },

            setEdited(v) {
                this.editProfile = true
                // console.log('profile edited: ' + v)
            },

            async gotoPayment() {
                this.fieldsErrors = []
                let hasErrors = false

                if (!isAuthenticated()) {
                    if (!this.email) {
                        hasErrors = true
                        this.fieldsErrors.push({
                            field: 'email',
                            message: this.$t('fill_in_email'),
                        })
                    }

                    if (!this.profile.name) {
                        hasErrors = true
                        this.fieldsErrors.push({
                            field: 'name',
                            message: this.$t('fill_in_name'),
                        })
                    }
                }

                if (!this.profile.phone) {
                    hasErrors = true
                    this.fieldsErrors.push({
                        field: 'phone',
                        message: this.$t('fill_in_phone'),
                    })
                }
                if (hasErrors) return

                if (!isAuthenticated()) {
                    // если пользователь не зарегистрирован ранее, то регистрируем его указанным e-mail
                    // если пользователь с таким e-mail уже существует, то отправлем его на форму логина
                    try {
                        this.user = await userApi.orderRegistration(this.profile.name, this.email, this.profile.phone)
                        console.log('user', this.user)
                        JwtService.saveUser(this.user)
                        userApi.pushUserContext()
                    } catch (error) {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                            //Если пользователь с таким e-mail уже существует, отправляем его на форму логина
                            this.fieldsErrors.filter(field => {
                                if (field.code === 'emailExists') this.existingEmail = this.email
                                if (field.code === 'phoneExists') this.existingPhone = this.profile.phone

                            })
                        } else {
                            this.error = this.pretty(data)
                        }
                        return
                    }
                }


                if (isAuthenticated()) {
                    userApi.utm()
                    this.disablePayButton = true
                    if (this.editProfile) {
                        this.profile.user_id = this.user.id
                        await this.submitProfileChange()
                    }

                    CStorage.setItem('ORD_CUR_phone', this.phone)
                    CStorage.setItem('ORD_CUR_comment', this.comment)

                    if (parseInt(this.course.price) === 0) {
                        let cid = ''
                        if (this.$metrika && this.$metrika.getClientID()) cid = btoa(this.$metrika.getClientID())
                        await axios({url: '/payment/getfree?idcourse=' + this.idcourse + '&cid=' + cid})
                        this.$router.push('/paymentstatus/free?idcourse=' + this.idcourse)
                    } else {
                        console.log(this.promocode)
                        let params = []
                        if (this.promocode) params.push('promocode=' + this.promocode)
                        if (this.recurrentParam) params.push('recurrent=true')
                        if (!this.fullPrice) params.push('partial')
                        if (this.$route.query.hasOwnProperty('add')) params.push('add')
                        if (this.$route.query.hasOwnProperty('addonly')) params.push('addonly')
                        this.$router.push('/payment/' + this.idcourse + (params.length ? ('?' + params.join('&')) : ''))
                    }
                }
            },

            isRegistered() {
                console.log("isAuthenticated()", isAuthenticated())
                return this.user.email != null
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },


            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            isAuthenticated() {
                return isAuthenticated()
            },

            returnUrl() {
                return window.location.pathname.replace(process.env.VUE_APP_PUBLIC_PATH, '/')
            }
        }
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
